<div>

  <!-- Toolbar superiore -->
  <tool-bar @esci="esci" :utente="utente" :mail="mail" :menu="menu"
    @toggle-drawer="drawer = !drawer"></tool-bar>

  <!-- Progress bar -->
  <v-progress-linear v-bind:indeterminate="true" v-show="loading" color="#000"
    class="mt-0 progress-bar" height="3">
  </v-progress-linear>

  <!-- Sidebar laterale sinistra -->
  <left-bar v-if="!isDemo" :menu="menu" v-model="drawer"
    @esci="esci"></left-bar>

  <!-- Sizes your content based upon application components -->
  <v-main class="pa-0">

    <!-- Provides the application the proper gutter -->
    <v-container fluid class="py-0">
      <pagina-demo v-if="isDemo" />
      <router-view v-else />
    </v-container>
  </v-main>

</div>